export default __webpack_public_path__ + "static/media/face1.f84234fc.jpg";